import React, { useEffect, useState } from 'react'

import { useActionless, useAppSelector } from 'redux/hooks'
import { selectOwnsDeck } from 'redux/deck/selectors'
import { TOGGLE_MODAL } from 'redux/active/actions/types'

import PlaygroupGGService from 'services/playgroupGG.service'
import ToastService from 'services/toast.service'

import Link from 'components/elements/Link'
import SimpleSpinner from 'components/elements/SimpleSpinner'
import { SimpleButton } from 'components/formElements/Button'

import styles from './playgroupData.module.scss'

const PlaygroupData = () => {
  const ownsDeck = useAppSelector(selectOwnsDeck)
  const playgroupDeckUrl = useAppSelector(state => state.deck.playgroupDeckUrl)

  const [toggleModal] = useActionless(TOGGLE_MODAL)

  const [loading, setLoading] = useState(true)
  const [powerLevel, setPowerLevel] = useState<number | null>(null)

  useEffect(() => {
    if (!playgroupDeckUrl) return setLoading(false)

    PlaygroupGGService.getDeckFromUrl(playgroupDeckUrl)
      .then(res => setPowerLevel(res.power_level))
      .catch(() => ToastService.create('error', 'Failed to load Playgroup.gg data'))
      .finally(() => setLoading(false))
  }, [playgroupDeckUrl])

  if (!playgroupDeckUrl) return null

  return (
    <div className={styles.container}>
      <img src="/images/playgroup_gg.svg" alt="Playgroup dot gg logo" height={12} width={12} />
      <span className={styles.header}>Power level:</span>

      <Link className={styles.color} href={playgroupDeckUrl || 'https://playgroup.gg/'} target="_blank">
        {powerLevel !== null && `${powerLevel}`}
        {powerLevel === null && !loading && 'N/A'}
      </Link>

      {loading && <SimpleSpinner size="xSmall" />}
      {!loading && ownsDeck && (
        <SimpleButton
          className={styles.editIcon}
          icon="cog"
          onClick={() => toggleModal({ modalName: 'playgroupForm', flag: true })}
        />
      )}
    </div>
  )
}

export default PlaygroupData
